// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2kCG3","buttons":"SendReceipts_buttons__IPu9k","email":"SendReceipts_email__3duBk","bookApptTitle":"SendReceipts_bookApptTitle__DGFcs"};